import React, { useState } from 'react';
export function RestaurantProfitCalculator() {
  const [dailyCustomers, setDailyCustomers] = useState(100);
  const [orderingPercentage, setOrderingPercentage] = useState(70);
  const [bottleCasesPerMonth, setBottleCasesPerMonth] = useState(20);
  const [caseCost, setCaseCost] = useState(30);
  const [menuPrice, setMenuPrice] = useState(2.0);
  // Calculations
  const customersPerMonth = dailyCustomers * 30;
  const waterCustomersPerMonth = customersPerMonth * orderingPercentage / 100;
  // Traditional bottled water costs (savings)
  const traditionalMonthlyCost = bottleCasesPerMonth * caseCost;
  // WELLHAUS revenue
  const wellhausMonthlyRevenue = waterCustomersPerMonth * menuPrice;
  // WELLHAUS lease cost (using $350/month from new pricing)
  const wellhausLeaseCost = 350;
  // Net profit calculation
  const wellhausNetProfit = wellhausMonthlyRevenue - wellhausLeaseCost + traditionalMonthlyCost;
  // Annual profit
  const annualProfit = wellhausNetProfit * 12;
  // Format number with commas
  const formatNumber = (num: number) => {
    return Math.round(num).toLocaleString('en-US');
  };
  return <div className="bg-white rounded-2xl shadow-2xl p-8 md:p-12" data-id="element-65">
      <h3 className="text-3xl md:text-4xl font-light mb-4 text-center" data-id="element-66">
        Restaurant Beverage Profit Calculator
      </h3>
      <p className="text-lg text-gray-600 text-center mb-12 max-w-3xl mx-auto" data-id="element-67">
        See how the WELLHAUS™ Drinkstation can transform your restaurant's
        beverage profit margins. Adjust the parameters below based on your
        business.
      </p>

      <div className="grid md:grid-cols-2 gap-12 mb-12" data-id="element-68">
        {/* Input Controls */}
        <div className="space-y-8" data-id="element-69">
          {/* Daily Customers */}
          <div data-id="element-70">
            <label className="flex items-center justify-between mb-3" data-id="element-71">
              <span className="text-base font-medium text-gray-900" data-id="element-72">
                Average Daily Customers
              </span>
              <span className="text-2xl font-light text-gray-900" data-id="element-73">
                {dailyCustomers}
              </span>
            </label>
            <input type="range" min="20" max="500" step="10" value={dailyCustomers} onChange={e => setDailyCustomers(Number(e.target.value))} className="w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer accent-gray-900" data-id="element-74" />
            <div className="flex justify-between text-xs text-gray-500 mt-1" data-id="element-75">
              <span data-id="element-76">20</span>
              <span data-id="element-77">500</span>
            </div>
          </div>

          {/* Ordering Percentage */}
          <div data-id="element-78">
            <label className="flex items-center justify-between mb-3" data-id="element-79">
              <span className="text-base font-medium text-gray-900" data-id="element-80">
                % Ordering Water (typically 70%)
              </span>
              <span className="text-2xl font-light text-gray-900" data-id="element-81">
                {orderingPercentage}%
              </span>
            </label>
            <input type="range" min="30" max="100" step="5" value={orderingPercentage} onChange={e => setOrderingPercentage(Number(e.target.value))} className="w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer accent-gray-900" data-id="element-82" />
            <div className="flex justify-between text-xs text-gray-500 mt-1" data-id="element-83">
              <span data-id="element-84">30%</span>
              <span data-id="element-85">100%</span>
            </div>
          </div>

          {/* Bottle Cases Per Month */}
          <div data-id="element-86">
            <label className="flex items-center justify-between mb-3" data-id="element-87">
              <span className="text-base font-medium text-gray-900" data-id="element-88">
                Cases (12 × 1L) Used Monthly
              </span>
              <span className="text-2xl font-light text-gray-900" data-id="element-89">
                {bottleCasesPerMonth}
              </span>
            </label>
            <input type="range" min="5" max="100" step="5" value={bottleCasesPerMonth} onChange={e => setBottleCasesPerMonth(Number(e.target.value))} className="w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer accent-gray-900" data-id="element-90" />
            <div className="flex justify-between text-xs text-gray-500 mt-1" data-id="element-91">
              <span data-id="element-92">5</span>
              <span data-id="element-93">100</span>
            </div>
          </div>

          {/* Case Cost */}
          <div data-id="element-94">
            <label className="flex items-center justify-between mb-3" data-id="element-95">
              <span className="text-base font-medium text-gray-900" data-id="element-96">
                Cost Per Case ($20-$45)
              </span>
              <span className="text-2xl font-light text-gray-900" data-id="element-97">
                ${caseCost}
              </span>
            </label>
            <input type="range" min="20" max="45" step="1" value={caseCost} onChange={e => setCaseCost(Number(e.target.value))} className="w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer accent-gray-900" data-id="element-98" />
            <div className="flex justify-between text-xs text-gray-500 mt-1" data-id="element-99">
              <span data-id="element-100">$20</span>
              <span data-id="element-101">$45</span>
            </div>
          </div>

          {/* Menu Price */}
          <div data-id="element-102">
            <label className="flex items-center justify-between mb-3" data-id="element-103">
              <span className="text-base font-medium text-gray-900" data-id="element-104">
                WELLHAUS Menu Price Per Person
              </span>
              <span className="text-2xl font-light text-gray-900" data-id="element-105">
                ${menuPrice.toFixed(2)}
              </span>
            </label>
            <input type="range" min="1" max="5" step="0.25" value={menuPrice} onChange={e => setMenuPrice(Number(e.target.value))} className="w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer accent-gray-900" data-id="element-106" />
            <div className="flex justify-between text-xs text-gray-500 mt-1" data-id="element-107">
              <span data-id="element-108">$1.00</span>
              <span data-id="element-109">$5.00</span>
            </div>
          </div>
        </div>

        {/* Results */}
        <div className="space-y-6" data-id="element-110">
          <div className="bg-gradient-to-br from-gray-900 to-gray-800 rounded-xl p-6 text-white" data-id="element-111">
            <h4 className="text-sm font-medium text-gray-300 mb-4" data-id="element-112">
              WELLHAUS™ Drinkstation
            </h4>
            <div className="space-y-3" data-id="element-113">
              <div className="flex justify-between items-center" data-id="element-114">
                <span className="text-gray-200" data-id="element-115">Monthly Lease</span>
                <span className="text-xl font-light" data-id="element-116">
                  -${formatNumber(wellhausLeaseCost)}
                </span>
              </div>
              <div className="flex justify-between items-center" data-id="element-117">
                <span className="text-gray-200" data-id="element-118">Monthly Revenue</span>
                <span className="text-xl font-light text-green-400" data-id="element-119">
                  +${formatNumber(wellhausMonthlyRevenue)}
                </span>
              </div>
              <div className="flex justify-between items-center" data-id="element-120">
                <span className="text-gray-200" data-id="element-121">Savings on Bottled Water</span>
                <span className="text-xl font-light text-green-400" data-id="element-122">
                  +${formatNumber(traditionalMonthlyCost)}
                </span>
              </div>
              <div className="border-t border-gray-600 pt-3 mt-3" data-id="element-123">
                <div className="flex justify-between items-center" data-id="element-124">
                  <span className="font-medium" data-id="element-125">Net Monthly Profit</span>
                  <span className="text-2xl font-light text-green-400" data-id="element-126">
                    +${formatNumber(wellhausNetProfit)}
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div className="bg-green-50 border-2 border-green-200 rounded-xl p-6" data-id="element-127">
            <h4 className="text-sm font-medium text-green-900 mb-4" data-id="element-128">
              Your Annual Profit
            </h4>
            <div className="flex justify-between items-center" data-id="element-129">
              <span className="text-green-900 font-medium" data-id="element-130">Annual Profit</span>
              <span className="text-3xl font-light text-green-600" data-id="element-131">
                +${formatNumber(annualProfit)}
              </span>
            </div>
          </div>

          <div className="text-sm text-gray-600 italic" data-id="element-132">
            * Based on {formatNumber(waterCustomersPerMonth)} water orders per
            month ({dailyCustomers} customers/day × 30 days ×{' '}
            {orderingPercentage}%)
          </div>
        </div>
      </div>

      <div className="bg-blue-50 border border-blue-200 rounded-xl p-6 text-center" data-id="element-133">
        <p className="text-base text-gray-700 mb-4" data-id="element-134">
          <strong data-id="element-135">Plus additional benefits:</strong> Reduced plastic waste,
          premium brand positioning, improved customer satisfaction, and Section
          179 tax deductions.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-136">
          <a href="https://form.typeform.com/to/ghKfSrez" target="_blank" rel="noopener noreferrer" className="px-8 py-3 bg-gray-900 text-white text-base font-medium rounded-full hover:bg-gray-800 transition-colors" data-id="element-137">
            Request a Demo
          </a>
          <a href="https://calendly.com/-smartsoda/discoverycall" target="_blank" rel="noopener noreferrer" className="px-8 py-3 border-2 border-gray-900 text-gray-900 text-base font-medium rounded-full hover:bg-gray-900 hover:text-white transition-colors" data-id="element-138">
            Contact Sales
          </a>
        </div>
      </div>
    </div>;
}